import styles from "../../styles/_sections/_coupon/couponsList.module.scss";

const CouponsList = () => {
  return (
    <div className={styles.container}>
      <h2>List of coupons</h2>

      <table>
        <thead>
          <tr>
            {/* code */}
            <th>Code</th>
            {/* discount % */}
            <th>Discount</th>
            {/* validity */}
            <th>Validity</th>
            {/* delete */}
            <th>Delete</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>shabat</td>
            <td>25%</td>
            <td>Unlimited</td>
            <td>
              <p>&times;</p>
            </td>
          </tr>
          <tr>
            <td>shabat</td>
            <td>25%</td>
            <td>22/12/2022</td>
            <td>
              <p>&times;</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CouponsList;
